import { render, staticRenderFns } from "./jiazhengfuwu.vue?vue&type=template&id=1b71ee19&scoped=true"
import script from "./jiazhengfuwu.vue?vue&type=script&lang=js"
export * from "./jiazhengfuwu.vue?vue&type=script&lang=js"
import style0 from "./jiazhengfuwu.vue?vue&type=style&index=0&id=1b71ee19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b71ee19",
  null
  
)

export default component.exports